function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9609 5.5C10.5625 5.5 10.1875 5.28906 10 4.96094L8.5 2.45312L6.97656 4.96094C6.78906 5.3125 6.41406 5.52344 6.01562 5.52344C5.89844 5.52344 5.80469 5.5 5.71094 5.47656L2.5 4.53906V8.71094C2.5 9.0625 2.73438 9.36719 3.0625 9.4375L8.125 10.7266C8.35938 10.7734 8.61719 10.7734 8.85156 10.7266L13.9141 9.4375C14.2656 9.36719 14.5 9.0625 14.5 8.71094V4.53906L11.2891 5.47656C11.1719 5.5 11.0781 5.5 10.9609 5.5ZM15.9531 2.875L14.7344 0.460938C14.6641 0.320312 14.5234 0.25 14.3594 0.273438L8.5 1L10.6328 4.58594C10.7266 4.72656 10.9141 4.79688 11.0781 4.75L15.7188 3.41406C15.9531 3.34375 16.0469 3.08594 15.9531 2.875ZM2.24219 0.460938L1.02344 2.875C0.929688 3.08594 1.04688 3.34375 1.25781 3.41406L5.89844 4.75C6.0625 4.79688 6.25 4.72656 6.34375 4.5625L8.5 1L2.61719 0.273438C2.45312 0.25 2.3125 0.320312 2.24219 0.460938Z",
  fill: "#757575"
});

var SvgBox = function SvgBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/box.b05dc040.svg";
export { ForwardRef as ReactComponent };